import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const getCardStatus = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const cardStatus = (await makeRequest('getCardStatus', { CDCONSUMIDOR }))?.data
    return cardStatus
}

const toggleCardStatus = async function (status) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const newStatus = status === '1' ? 2 : 1
    const cardStatus = (await makeRequest('toggleCardStatus', { CDCONSUMIDOR, newStatus }))?.data
    return cardStatus
}

const setCardStatus = async function (CDCONSUMIDOR, newStatus) {
    const cardStatus = (await makeRequest('toggleCardStatus', { CDCONSUMIDOR, newStatus }))?.data
    return cardStatus
}

const getFlagCards = function (number) {
    const cardNumber = number.replace(/[^0-9]+/g, '')

    const cards = {
        visa: /^4[0-9]{12}(?:[0-9]{3})/,
        mastercard: /^5[1-5][0-9]{14}/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
        amex: /^3[47][0-9]{13}/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
        hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
        elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}/,
        aura: /^((?!504175))^((?!5067))(^50[0-9])/
    }
    let flag = ''
    Object.keys(cards).forEach(e => {
        const re = new RegExp(cards[e])
        if (re.test(cardNumber)) {
            flag = e
        }
    })
    return flag
}

const updateStoredCards = async function (CDCLIENTE, CDCONSUMIDOR) {
    const cards = (await makeRequest('getCards', { CDCLIENTE, CDCONSUMIDOR }))?.data
    store.dispatch('setCards', cards)
}

const registerNewCard = async function () {
    const newCreditCard = store.getters.newCardValues
    const baseInfo = store.getters.getBaseInfo
    const consumers = store.getters.dependentsList
    const payload = {
        CDCLIENTE: baseInfo.CDCLIENTE,
        CDFILIAL: baseInfo.CDFILIAL,
        CDCONSUMIDOR: consumers[0].CDCONSUMIDOR,
        HOLDERNAME: newCreditCard.nomedotitular.trim(),
        NUMBERS: newCreditCard.numerodocartao.replaceAll(' ', ''),
        EXPDATE: newCreditCard.validade,
        FLAG: newCreditCard.flag,
        CVV: newCreditCard.cvv,
        DEFAULT: newCreditCard.tornarestecartaoprincipal
    }
    const result = (await makeRequest('registerCreditCard', payload))?.data
    if (result && !result.error) {
        await updateStoredCards(payload.CDCLIENTE, payload.CDCONSUMIDOR)
    } else {
        store.dispatch('showModalInfo', { type: 'error', text: result.message, open: true })
    }
    return result
}

const deleteCreditCard = async function (creditCard) {
    const payload = { CDCARTCRED: creditCard.CDCARTCRED }
    const result = (await makeRequest('deleteCreditCard', payload))?.data
    if (result && !result.error) {
        updateStoredCards(creditCard.CDCLIENTE, creditCard.CDCONSUMIDOR)
        store.dispatch('showModalInfo', { type: 'success', text: result.message, open: true })
    } else {
        store.dispatch('showModalInfo', { type: 'error', text: result.message, open: true })
    }
    return result
}

export {
    getCardStatus,
    toggleCardStatus,
    setCardStatus,
    getFlagCards,
    registerNewCard,
    updateStoredCards,
    deleteCreditCard
}
